module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "id": "nowyu",
      "fixedFooter": ""
    }
  }, [(_vm.showToolbar()) ? _c('main-toolbar') : _vm._e(), _vm._v(" "), _c('main', {
    staticStyle: {
      "padding-bottom": "56px"
    }
  }, [_c('v-slide-y-transition', {
    attrs: {
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    staticClass: "notification",
    attrs: {
      "timeout": _vm.snackbarTimeout,
      "bottom": _vm.snackbarBottom,
      "success": _vm.snackbarColor === 'success',
      "info": _vm.snackbarColor === 'info',
      "warning": _vm.snackbarColor === 'warning',
      "error": _vm.snackbarColor === 'error',
      "primary": _vm.snackbarColor === 'primary',
      "secondary": _vm.snackbarColor === 'secondary',
      "multi-line": _vm.snackbarMode === 'multi-line',
      "vertical": _vm.snackbarMode === 'vertical'
    },
    model: {
      value: (_vm.showSnackbar),
      callback: function($$v) {
        _vm.showSnackbar = $$v
      },
      expression: "showSnackbar"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.snackbarText) + "\n        "), _c('v-btn', {
    attrs: {
      "flat": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snack('', '')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.showFooter()) ? _c('footer-navigation') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fb5f752","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/MainLayout.vue
// module id = 338
// module chunks = 2